import tinycolor2 from 'tinycolor2';

export const isDarkColor = (color, image) => {
    return new Promise<boolean>((resolve) => {
        if (!image) {
            if (color?.includes('linear-gradient')) {
                resolve(false);
            } else {
                resolve(getColorBrightness(color) < 128);
            }
        } else {
            return getImageBrightness(image);
        }
    });
};

export const getColorBrightness = (color) => {
    return tinycolor2(color).getBrightness();
};
export const getImageBrightness = (imageSrc) => {
    return new Promise((resolve, reject) => {
        const img = document.createElement('img');
        img.src = imageSrc;
        img.style.display = 'none';
        img.setAttribute('crossOrigin', '');
        document.body.appendChild(img);

        let colorSum = 0;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            let r, g, b, avg;

            for (let x = 0, len = data.length; x < len; x += 4) {
                r = data[x];
                g = data[x + 1];
                b = data[x + 2];

                avg = Math.floor((r + g + b) / 3);
                colorSum += avg;
            }

            const brightness = Math.floor(colorSum / (img.width * img.height));
            resolve(brightness);
        };
        img.onerror = (e) => {
            reject(e);
        };
    });
};
